export default (e) => {
  if (e?.code && e.code === 'ERR_NETWORK') {
    return 'Sem conexão com a internet';
  }

  if (e?.response?.data?.error) {
    return e.response.data.error;
  }
  if (e?.response?.data?.message) {
    return e.response.data.message;
  }
  const mensagemPadrao = 'Ocorreu um erro ao tentar salvar o registro';
  if (e?.response?.request?.response) {
    const { response } = e.response.request;
    try {
      return JSON.parse(response).mensagem;
    } catch (notJsonException) {
      return mensagemPadrao;
    }
  }

  if (e.message) {
    return e.message;
  }

  return mensagemPadrao;
};
